export default {
  data() {
    return {
      effortRateHourly: {
        1: 0.1238,
        2: 0.1032,
        3: 0.0826,
        4: 0.062,
        5: 0.062,
        6: 0.062,
        7: 0.062,
        8: 0.0412,
        9: 0.0412,
      },
      hourlyWageReference: 10.38,
      isCustomMonthlySalary: false,
      // The rate limit to which the CMG applies
      maxNetHelp: 15,
      averageMonthlySalaryRange: [1426, 2000, 4000, 6000],
    };
  },
  computed: {
    averageMonthlySalaries() {
      return this.isCustomMonthlySalary ? [this.averageMonthlySalaryParsed] : this.averageMonthlySalaryRange;
    },
    /***
     *
     *  New CMG calculations
     *
     ***/

    /*****
     * This is the real total amount (net) paid to the assmat
     * including allowances (meal + transport + maintenance)
     ****/
    realMonthlyRateNet() {
      return this.net_mensualization_classic + this.net_monthy_overtime_increase;
    },
    realHourlyRateNet() {
      return this.realMonthlyRateNet / this.monthly_hours_f;
    },
    /*****
     * As we have a maximum of 8€ / hour (net) as rate paid for the cmg
     * we need to take the 8 euro if the amount paid to the assmat goes beyond
     ****/
    maxRealHourlyRate() {
      return Math.min(this.realHourlyRateNet, this.maxNetHelp);
    },
    youngestChildAgeTooOld() {
      return this.child_age.toString() === '6';
    },
    cmgNotAvailable() {
      return this.youngestChildAgeTooOld || this.cmgAidToggle === 'no';
    },
  },
  methods: {
    cmgEligibleAmount(parentMonthlySalaryNet) {
      if (this.cmgNotAvailable || parentMonthlySalaryNet < 0) {
        return 0;
      }

      return this.cmgPayable(parentMonthlySalaryNet) *
          (this.handicap_toggle ? 1.3 : 1) *
          (this.cmgAidToggle === 'partial' ? 0.5 : 1);
    },

    /*****
     * Formula to calculate the new CMG 2025
     * ```
     * real hourly rate * monthly worked hours * ( 1 - ( net parent salary * hourly effort rate / gross hourly rate reference) )
     * ```
     *****/
    cmgPayable(parentMonthlySalaryNet) {
      const cmgAmount = this.maxRealHourlyRate * this.monthly_hours_f *
          (1 - (parentMonthlySalaryNet * this.effortRateHourly[this.children_i] / 100 / this.hourlyWageReference));
      return Math.max(0, cmgAmount);
    },
    /**
     * Taxes credit
     * We need to get the total of the expenses over the year for the employer
     * Total salary + Total contribution by employer - Abatement Employer charges - Aids for social contribution - CMG aids - other aids
     * Only 50% of the expenses will be used as taxes credit
     * This calculation is made for the year and the amount that can be paid is ceiled to 12000 € depending on cases
     * @param parentMonthlySalaryNet
     * @returns {number}
     */
    taxesCredit(parentMonthlySalaryNet) {
      const taxMax = Math.max(
        (
          this.grossTotal +
              this.social_contributions_employer -
              this.employerContributionsReduction -
              this.socialContributionsCredit -
              this.cmgEligibleAmount(parentMonthlySalaryNet) -
              this.other_aid_f
        ) * 12 / 2,
        0
      );

      return Math.min(taxMax, this.creditTaxCeil);
    },
    amountLeftPayable(parentMonthlySalaryNet) {
      return Math.max(
        this.amountLeftPayableBeforeTaxes(parentMonthlySalaryNet) -
          (this.taxesCredit(parentMonthlySalaryNet) / 12),
        0
      );
    },
    amountLeftPayableBeforeTaxes(parentMonthlySalaryNet) {
      return Math.max(this.total_amount -
          this.socialContributionsCredit -
          this.employerContributionsReduction -
          this.cmgEligibleAmount(parentMonthlySalaryNet) -
          this.other_aid_f, 0);
    },
    dailyCost(parentMonthlySalaryNet) {
      return this.amountLeftPayable(parentMonthlySalaryNet) / this.monthly_worked_days_f;
    },
    hourlyCost(parentMonthlySalaryNet) {
      return this.amountLeftPayable(parentMonthlySalaryNet) / this.monthly_hours_f;
    },

  },
};
